import type {
  ChatSourceFssFile,
  ChatSourceFssFolder,
} from "@mirage/mosaics/Chat/types";
import type {
  FSSFile,
  FSSFolder,
} from "@mirage/service-fss-bridge/service/bridge_types";

export const convertFssEntityToChatSource = (
  entity: FSSFile | FSSFolder,
): ChatSourceFssFile | ChatSourceFssFolder => {
  if (entity.type === "file") {
    return convertFssFileToChatSource(entity);
  }
  return convertFssFolderToChatSource(entity);
};

const convertFssFileToChatSource = (file: FSSFile): ChatSourceFssFile => {
  const fullFileName = file.name;
  const fileNameParts = fullFileName.split(".");

  const name = fileNameParts.shift() ?? file.name;
  const extension = fileNameParts.length > 0 ? fileNameParts.pop() : undefined;

  return {
    type: "fss_file",
    fileId: file.fileId,
    name,
    url: file.href ?? null,
    extension,
  };
};

const convertFssFolderToChatSource = (
  folder: FSSFolder,
): ChatSourceFssFolder => {
  return {
    type: "fss_folder",
    fileId: folder.fileId,
    path: folder.path,
    name: folder.path.split("/").pop() ?? undefined,
  };
};
